<template>
  <v-flex xs12 class="homeFooter white--text">
    <v-layout row class="primary" style="height: 450px; padding: 100px 5%;">
      <v-flex xs7 pr-5 style="position: relative; display: flex; flex-direction: column; justify-content: space-between">
        <div class="footerTitle">Quick Links</div>
        <v-flex xs12 class="quickLinks" style="flex: none">
          <v-layout row wrap style="display: flex; justify-content: space-between">
            <div style="font-size: 18px">
              <div style="font-weight: 800">SERVICES</div>
              <div v-for="(item, index) in footerLinks" :key="index" v-if="item.category === 'services'">
                <a :href="item.link" class="secondary--text" target="_blank">{{item.name}}</a>
              </div>
            </div>
            <div style="font-size: 18px">
              <div style="font-weight: 800">HELP</div>
              <div v-for="(item, index) in footerLinks" :key="index" v-if="item.category === 'help'">
                <a :href="item.link" class="secondary--text" target="_blank">{{item.name}}</a>
              </div>
            </div>
            <div style="font-size: 18px">
              <div style="font-weight: 800">SECURITY</div>
              <div v-for="(item, index) in footerLinks" :key="index" v-if="item.category === 'security'">
                <a :href="item.link" class="secondary--text" target="_blank">{{item.name}}</a>
              </div>
            </div>
            <div style="font-size: 18px">
              <div style="font-weight: 800">COMPANY</div>
              <div v-for="(item, index) in footerLinks" :key="index" v-if="item.category === 'company'">
                <a :href="item.link" class="secondary--text" target="_blank">{{item.name}}</a>
              </div>
            </div>
          </v-layout>
        </v-flex>
        <div class="footerDivider"></div>
      </v-flex>
      <v-flex xs5 pl-5>
        <div class="footerTitle">Keep in touch!</div>
        <div class="stayConnected">
          <div style="font-size: 14px">Subscribe to our newsletter and get latest news and announcements.</div>
          <div style="margin-top: 30px;" class="subscribeField">
            <v-text-field
              color="secondary"
              dark
              outline
              hide-details
              v-on:keyup.enter='subscribeUser'
              placeholder="Email Address"
              v-model="userEmail"
            ></v-text-field>
            <v-btn flat round :ripple="false" class="noHoverBtn secondary primary--text" style="margin: 0; margin-top: 10px; width: 180px; height: 45px" @click="subscribeUser()">Let's Go!</v-btn>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row style="height: 90px; padding: 0px 5%; background-color: #0E2F57; display: flex; align-items: center; justify-content: space-between">
      <div style="font-size: 18px;">© 2019 Yakshof. All rights reserved.</div>
      <div style="height: 100%; display: flex; align-items: center">
        <a target="_blank" href="https://www.facebook.com/yakshof/" style="margin-right: 30px;"><img style="max-height: 20px" src="@/assets/facebook.png"/></a>
        <a target="_blank" href="https://twitter.com/yakshof" style="margin-right: 30px;"><img style="max-height: 20px" src="@/assets/twitter.png"/></a>
        <a target="_blank" href="" style="margin-right: 30px;"><img style="max-height: 20px" src="@/assets/instagram.png"/></a>
      </div>
    </v-layout>
  </v-flex>
</template>

<style>
  .footerDivider{
    position: absolute;
    right: 0px;
    height: calc(100% + 100px);
    border-left: 1px solid #0C4991;
    top: -50px;
  }
  .noHoverBtn:hover:before{
    background-color: transparent;
  }
  .subscribeField .v-input__slot{
    border-radius: 50px !important;
    border-width: 1px !important;
    min-height: 45px !important;
    height: 45px !important;
  }
  .subscribeField input{
    padding: 0 !important;
    margin: 0 !important;
  }
  .subscribeField .v-text-field__slot{
    display: flex;
    align-items: center;
  }
  .footerTitle{
    font-size: 36px;
    font-weight: 800;
    margin-bottom: 10px;
  }
  .quickLinks a{
    text-decoration: none;
    font-size: 16px;
  }
  .subscribeField input, .subscribeField label{
    font-size: 18px;
    color: white !important;
  }
  .subscribeField .v-text-field__suffix{
    font-size: 14px;
    font-weight: 600;
  }
</style>

<script>
export default {
  data () {
    return {
      subscriptionLoading: false,
      subscriptionSuccess: false,
      footerLinks: [
        {link: '/#/market', name: 'Browse Projects', category: 'services'},
        {link: '/#/diy', name: 'Create Project', category: 'services'},
        {link: 'https://app.dataslicer.io/#/demo', name: 'Free Demo', category: 'services'},
        {link: '/#/help', name: 'FAQ', category: 'help'},
        {link: '/#/', name: 'Support Ticket', category: 'help'},
        {link: '/#/', name: 'Privacy Policy', category: 'security'},
        {link: '/#/', name: 'Terms of Use', category: 'security'},
        {link: '/#/', name: 'About Us', category: 'company'},
        {link: '/#/', name: 'Team', category: 'company'},
        {link: '/#/', name: 'News', category: 'company'},
        {link: '/#/', name: 'Careers', category: 'company'},
        {link: '/#/', name: 'Contact', category: 'company'}
      ],
      userEmail: ''
    }
  },
  methods: {
    subscribeUser () {
      this.subscriptionLoading = true
      console.log(this.userEmail)
      this.subscriptionSuccess = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/appElements/Footer.vue